import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../../common/loader';
const ProcessingIndicator = ({
  message: _message = undefined
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": "processing-indicator",
  style: {
    textAlign: 'center'
  }
}, _message ? /*#__PURE__*/React.createElement("h4", null, _message) : '', /*#__PURE__*/React.createElement(Loader, null));
ProcessingIndicator.propTypes = {
  message: PropTypes.string
};
export default ProcessingIndicator;